

















import { defineComponent } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { LoginSignUpModalData } from "@/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import LocaleSwitch from "@/components/LocaleSwitch";

export default defineComponent({
  name: "GuestNavigationBar",
  components: { BaseButton, LocaleSwitch },
  setup() {
    const handleLoginClick = (data?: LoginSignUpModalData) => {
      emitter.emit(EVENTS.SHOW_LOGIN_SIGNUP_MODAL, { showLogin: data?.showLogin });
    };

    return { handleLoginClick };
  },
});
